import { render, staticRenderFns } from "./KnowledgeAssociation.vue?vue&type=template&id=3df09595&"
import script from "./KnowledgeAssociation.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeAssociation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports